export default "__VITE_ASSET__vCVJ4SZf__"